/**安装状态 */
export enum installStatus {
  NOT_INSTALL = '未安装',
  INSTALLING = '安装中',
  INSTALLED = '已安装'
}
/**硬件类型 */
export enum hardwardType {
  MAIN = '主柜',
  DEPUTY = '副柜'
}
/**全局 */
export enum GlobalEnum {
  /**最大上传数量 */
  MAX_UPLOAD = 200,
  /**jts header加密用key */

  /**X-SimplyPost-Id 固定个值就好 app用的是112 */
  X_SIMPLLYPOST_ID = 112,
  APK_VERSION = '9999'
}
/**交易类型 */
export enum BillLevelOneType {
  /**充值 */
  RECHARGE = '充值',
  /**提现 */
  WITHDRAWAL = '提现',
  /**运费支出 */
  TRANSPORTATION_OUTLAYS = '运费支出',
  /**站点返佣 */
  SEND_COMMISSION = '站点返佣',
  /**其他 */
  ACCOUNT_ADJUST = '其他'
}
/**派件---订单状态 */
export enum OrderStatusType {
  /**已取件 */
  PICKED_UP = '已取件',
  /**已取消 */
  CANCELLED = '已取消',
  /**已回收 */
  RECYCLED = '已回收',
  /**已投递 */
  DELIVERED = '已投递',
  // /**已退柜 */
  HAD_WITHDRAWAL = '已退柜',
  /**待投递 */
  TO_BE_DELIVERED = '待投递',
  /**签收不出库 */
  SIGN_NONE_OUT = '签收不出库',
  /**投递中 */
  // DELIVERY = '投递中',
  /**管理员取出 */
  ADMIN_OUT = '管理员取出'
}
/**订单标签 */
export enum OrderTagType {
  /**全部 */
  // ALL = '全部',
  /**COD */
  COD = 'COD',
  /**已取消 */
  CANCELLED = '已取消',
  /**滞留件 */
  STRANDED = '滞留件'
}
/**通知状态 */
export enum NoticeStatusType {
  /**未通知*/
  NOT_INFORM = '未通知',
  /**通知中 */
  NOTIFY = '通知中',
  /**通知失败 */
  NOTIFY_FAIL = '通知失败',
  /**通知成功 */
  NOTIFY_SUCCESS = '通知成功'
}
/**支付方式 */
export enum PayType {
  /**KT_BANK*/
  KT_BANK = 'KBank',
  /**线下 */
  OFF_LINE = 'CASH'
}
/**寄件订单状态 */
export enum SenderOrderStatusType {
  /**已取消 - 取消投递*/
  POST_CANCEL = '已取消 - 取消投递',
  /**已取消 - 投递超时 */
  POST_TIMEOUT_CANCEL = '已取消 - 投递超时',
  /**已取消 - 支付超时 */
  PAY_TIMEOUT_CANCEL = '已取消 - 支付超时',
  /**已取消-已取回 */
  CANCEL_PICK = '已取消 - 已取回',
  /**已取消待取回 / 已拒收*/
  CANCEL_WAIT_PICK = '已取消待取回 / 已拒收',
  /**已投递 */
  WAIT_RECEIVE = '已投递',
  /**待投递 */
  WAIT_POST = '待投递',
  /**快递员取出 / 已收件*/
  STAFF_OUT = '快递员取出 / 已收件',
  /**本人取出 */
  USER_OUT = '本人取出',
  /**用户已取消 */
  USER_CANCEL = '用户已取消'
  /**管理员取件 */
  // ADMIN_OUT = '管理员取件'
}
/**储物订单状态 */
export enum StorageOrderStatusType {
  /**存放中*/
  STORAGE = '存放中',
  /**已取消 */
  CANCELL = '已取消',
  /**已结束 */
  OVER = '已结束',
  /**待使用 */
  TO_BE_USED = '待使用',
  /**管理员取出*/
  ADMIN_OUT = '管理员取出'
}
/**储物服务类型 */
export enum StorageServerType {
  /**临时存放*/
  TEMPORARY_STORAGE = '临时存放',
  /**期租用 */
  LONG_RENT = '长期租用'
}

/**快递柜查询列表-启用状态 */
export enum EnableStatus {
  /**已启用*/
  ENABLE = '已启用',
  /**未启用 */
  NOT_ENABLE = '未启用',
  /**禁用 */
  DISABLE = '已禁用'
}
/**快递柜查询列表-网络状态 */
export enum NetWorkStatus {
  /**断开*/
  EXCEPTION = '断开',
  /**正常 */
  NORMAL = '正常'
}
/**钱包状态 */
export enum WalletStatus {
  /**冻结*/
  FREEZE = '冻结',
  /**正常 */
  THAW = '正常'
}
/**用户状态 */
export enum userStatus {
  ON = '已启用',
  OFF = '已禁用'
}

/**快递员钱包-操作明细-流水类型 */
export enum BudgetDetailType {
  /**快递员充值 */
  STAFF_CHARGE = '快递员充值',
  /**派件格口费 */
  DELIVER_BIN_FEE = '派件格口费',
  /**账户调账 */
  ACCOUNT_ADJUST = '账户调账'
}
/**收支明细  渠道商钱包里面的 流水类型*/
export enum distributorRunWaterType {
  WALLET_CHARGE = '钱包充值',
  DELIVER_FEE_STAFF = '派件费-快递员',
  ACCOUNT_ADJUST = '账户调账',
  DELIVER_FEE_DISTRIBUTOR = '派件费-渠道商',
  DISTRIBUTOR_WALLET_WITHDRAW = '钱包提现',
  // STAFF_WALLET_REFUND = '钱包退款',
  STAFF_REPEAT_BOX = '派件费-重新入柜-快递员',
  DISTRIBUTOR_REPEAT_BOX = '派件费-重新入柜-渠道商',
  STAFF_SMS_REPEAT = '派件费-重发取件码-快递员',
  DISTRIBUTOR_SMS_REPEAT = '派件费-重发取件码-渠道商',
  OVER_PICK_UP_FEE = '派件费-取件超时费',
  // SIGN_NONE_OUT = '派件费-签收不出库',
  DELIVER_FEE_DISTRIBUTOR_RETURN = '派件费取消退回-渠道商',
  DELIVER_FEE_STAFF_RETURN = '派件费取消退回-快递员',
  DELIVER_SIGN_NONE_OUT_STAFF = '签收不出库-快递员',
  DELIVER_SIGN_NONE_OUT_DISTRIBUTOR = '签收不出库-渠道商'
}
/**交易状态 */
export enum WalletTradeStatusEnum {
  APPLY,
  FAIL,
  SUCCESS,
  CANCEL
}

/**JTS code */
export enum JtsCode {
  上传成功 = 307,
  部分上传失败或全部上传失败 = 308,
  请求参数为空 = 9999,
  记录未找到 = 20002,
  系统错误 = 70000
}

/**格口状态 */
export enum binOrderType {
  /**寄件 */
  MAILING = '#6699FF',
  /**储物 */
  STORAGE = '#EC716A',
  /**派件 */
  DELIVERY = '#43B290'
}
/**运营类型 */
export enum serverType {
  INTERIOR_BOX = '室内柜',
  STATION_BOX = '驿站柜'
}
/**保管费 */
export enum StorageFee {
  'YES' = '>0'
}

/**交易状态 */
export enum payOrderStatusType {
  UNDERWAY = '交易进行中',
  CANCELL = '交易已取消',
  SUCCESS = '交易成功'
}
/**费用名称 */
export enum feePayType {
  STAFF_RECHARGE_PAY = '快递员派费充值',
  DISTRIBUTOR_RECHARGE_PAY = '渠道商充值',
  DISTRIBUTOR_WITHDRAW = '渠道商提现',
  PICK_UP_OVER_PAY = '取件超时费',
  STAFF_WITHDRAW = '快递员提现',
  REFUND = '微信退款'
}
export * from './langConst'
